import { apiClient, CancelToken } from '@/services/ApiClient.js'

let cancel

export default {
  getSalesReports(query) {
    return apiClient
      .get('sales-reports', {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c
        }),
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getUnderwritingDecisionReports(query) {
    return apiClient
      .get('underwriting-decision-reports', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSnapshots(query) {
    return apiClient
      .get('report-snapshots', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerPerformanceReports(query) {
    return apiClient
      .get('payment-performance-reports', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancePortfolioReportsByWeightedAverage(query) {
    return apiClient
      .get('finance-portfolio-reports/by-weighted-average', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancePortfolioReportsByProduct(query) {
    return apiClient
      .get('finance-portfolio-reports/by-product', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancePortfolioReportsByCity(query) {
    return apiClient
      .get('finance-portfolio-reports/by-city', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancePortfolioReportsByCounty(query) {
    return apiClient
      .get('finance-portfolio-reports/by-county', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancePortfolioReportsByRetailer(query) {
    return apiClient
      .get('finance-portfolio-reports/by-retailer', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancePortfolioReportByGrownProduct(query) {
    return apiClient
      .get('finance-portfolio-reports/by-grown-product', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrdersByPlatform(query) {
    return apiClient
      .get('mobile-report/orders-by-platform', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getApplicationsByPlatform(query) {
    return apiClient
      .get('mobile-report/applications-by-platform', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobilePricesByCity(query) {
    return apiClient
      .get('mobile-report/prices-by-city', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobilePricesByProductInCity(cityId, query) {
    return apiClient
      .get('mobile-report/prices-by-product-in-city', {
        params: { city_id: cityId, ...query }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobilePricesByRetailer(query) {
    return apiClient
      .get('mobile-report/prices-by-retailer', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobilePricesByProductForRetailer(retailerId, query) {
    return apiClient
      .get('mobile-report/prices-by-product-for-retailer', {
        params: { retailer_id: retailerId, ...query }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  cancelSalesReportRequest() {
    if (cancel) {
      cancel()
    }
  }
}
